"use client"

import { ReactNode } from "react"

import { Dialog, DialogContent } from "@/components/ui/dialog"
import { useRouter } from "next/navigation"

/**
 * This is a wrapper for the NFTModal componennt.
 *
 * This needs to be separate because:
 * 1) it's a client component
 * 2) It does an animation when it opens, so the fallback and the real body need to be
 * children of this.
 */
export default function NFTModalOuterDialog(props: { children: ReactNode }) {
  const router = useRouter()

  return (
    <Dialog
      defaultOpen
      open
      onOpenChange={() => {
        // If the Privy wallet connect modal is open, do not close NFT modal
        if (document.getElementById("privy-modal-content")) return
        router.back()
      }}
    >
      <DialogContent className="sm:max-w-[448px] p-0 sm:max-h-[90vh] max-h-[100vh] overflow-y-auto">
        {props.children}
      </DialogContent>
    </Dialog>
  )
}
